// this is a temporary fix for the post-migration issues for new appnexus seat

export default function duplicateApnKeywords(values) {
    const duplicates = {};

    Object.keys(values).forEach((key) => {
        if (key.indexOf('no-') === 0 || key.indexOf('aa-') === 0) {
            duplicates[`kw_${key}`] = values[key];
        }
    });

    return { ...values, ...duplicates };
}



/** WEBPACK FOOTER **
 ** ./src/utils/duplicate-apn-keywords.js
 **/